import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
render(<BrowserRouter data-id="element-774">
    <App data-id="element-775" />
  </BrowserRouter>, document.getElementById('root'));